var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ViewLayout',{scopedSlots:_vm._u([{key:"header-title",fn:function(){return [_vm._v(" View Support Ticket ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }